export class ProcessCompletionInfoRequest {
    EmployeeID: number;
    FileName: string;
}

export default ProcessCompletionInfoRequest;